var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var IpcSmdPadGeneratorInteractionModel = require('../ipcSmdPadGeneratorInteractionModel.js');
var PackageGeneratorInspectorConfig = require("../../packageGeneratorInspectorConfig.js");
var IpcImages = require("../../../../../shared/extensions/footprintGenerator/ipcImages/index.js");

var ECapPadGeneratorInteractionModel = function(parametricData, userSettingsModel, showFootprintParams, withCustomFootprintParams) {
    IpcSmdPadGeneratorInteractionModel.call(this, parametricData, userSettingsModel, showFootprintParams, withCustomFootprintParams);
};

lib_core.inherit(ECapPadGeneratorInteractionModel, IpcSmdPadGeneratorInteractionModel);
ECapPadGeneratorInteractionModel.$class = 'ECapPadGeneratorInteractionModel';

module.exports = ECapPadGeneratorInteractionModel;

ECapPadGeneratorInteractionModel.prototype.initialize = function() {
    var self = this;

    IpcSmdPadGeneratorInteractionModel.prototype.initialize.call(this);

    this.optionalDimensionList = [];

    //optional dimension list
    for (var t in cio_datamodel.IpcDataModel.ComponentAttribute.optionalDimensionInput) {
        var d = cio_datamodel.IpcDataModel.ComponentAttribute.optionalDimensionInput[t];
        this.optionalDimensionList.push([this.LCLZ(t, d), d]);
    };

    //used for only aluminum electrolytic component and crystal
    this.optionalDimension = this.shadow("optionalDimension",
        function() {
            return self.data.optionalDimension();
        },
        function(value) {  
            return self.data.optionalDimension(value);
        },
        [
        self.data.optionalDimension
        ]
    );

    this.hideOptionalDimD = this.shadow("hideOptionalDimD",
        function() {
            return (this.data.optionalDimension() !== cio_datamodel.IpcDataModel.ComponentAttribute.optionalDimensionInput["Optional_D"]);
        },
        null,
        [
            self.data.optionalDimension
        ]
    );

    this.hideOptionalDimD2 = this.shadow("hideOptionalDimD2",
        function() {
            return (this.data.optionalDimension() !== cio_datamodel.IpcDataModel.ComponentAttribute.optionalDimensionInput["Optional_D2"]);
        },
        null,
        [
            self.data.optionalDimension
        ]
    );

    this.hideOptionalDimL = this.shadow("hideOptionalDimL",
        function() {
            return (this.data.optionalDimension() !== cio_datamodel.IpcDataModel.ComponentAttribute.optionalDimensionInput["Optional_L"]);
        },
        null,
        [
            self.data.optionalDimension
        ]
    );

    this.terminalGapMin = this.shadow("terminalGapMin",
        function() {
            return self.data.terminalGapMin() / self.getUnitFactor();
        },
        function(value) {   
            return self.data.terminalGapMin(parseFloat(value) * self.getUnitFactor());
        }, [
            self.data.terminalGapMin, self.userSettingsModel.distanceUnit
        ]
    );

    this.terminalGapMax = this.shadow("terminalGapMax",
        function() {
            return self.data.terminalGapMax() / self.getUnitFactor();
        },
        function(value) {   
            return self.data.terminalGapMax(parseFloat(value) * self.getUnitFactor());
        }, [
            self.data.terminalGapMax, self.userSettingsModel.distanceUnit
        ]
    );
};

ECapPadGeneratorInteractionModel.prototype.getInspectorElementForLabel = function(label) {
    return [PackageGeneratorInspectorConfig.getLabel(label)];
};

ECapPadGeneratorInteractionModel.prototype.getInspectorElementForLeadSpan = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('D', this.LCLZ('leadSpan', 'Lead Span'), false, this.horizontalLeadToLeadSpanMin, false, this.horizontalLeadToLeadSpanMax, this.userSettingsModel.distanceUnit, '', this.hideOptionalDimD)];
};

ECapPadGeneratorInteractionModel.prototype.getInspectorElementForBodyLength = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('D1', this.LCLZ('bodyLength', 'Body Length'), false, this.bodyWidthMin, false, this.bodyWidthMax, this.userSettingsModel.distanceUnit)];
};

ECapPadGeneratorInteractionModel.prototype.getInspectorElementForTerminalGap = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('D2', this.LCLZ('terminalGap', 'Terminal Gap'), false, this.terminalGapMin, false, this.terminalGapMax, this.userSettingsModel.distanceUnit, '', this.hideOptionalDimD2)];
};

ECapPadGeneratorInteractionModel.prototype.getInspectorElementForOptionalDiamension = function() {
    return [PackageGeneratorInspectorConfig.getSelectbox(this.LCLZ('optionalDimension', 'Optional Dimension'), this.optionalDimension, this.optionalDimensionList)];
};

ECapPadGeneratorInteractionModel.prototype.getInspectorElementForTerminalLength = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('L', this.LCLZ('terminalLength', 'Terminal Length'), false, this.padWidthMin, false, this.padWidthMax, this.userSettingsModel.distanceUnit, '', this.hideOptionalDimL)];
};

ECapPadGeneratorInteractionModel.prototype.getInspectorElements = function() {
    var imElements = [];

    //custom footprint settings
    if (this.withCustomFootprintParams() && this.showFootprintParams()) {
        imElements = imElements.concat(this.getInspectorElementForEnablingCustomFootprint());
        imElements = imElements.concat(this.getInspectorElementForCustomFootprintImage(IpcImages.customFootprintEcap));
        imElements = imElements.concat(this.getInspectorElementForCustomFootprintNormalPadSettings());
        imElements = imElements.concat(this.getInspectorElementForPadGapInCustomFootprint());
    };
    imElements = imElements.concat(this.getInspectorElementForPadShape());
    imElements = imElements.concat(this.getInspectorElementForPadRoundness());
    imElements = imElements.concat(this.getInspectorElementForDensityLevel());
    imElements = imElements.concat(this.getInspectorElementForLabel(this.LCLZ('ecapNote', '* Select optional dimension from (D, D2, L). Different combinations may produce different footprint pad sizes.')));
    imElements = imElements.concat(this.getInspectorElementForOptionalDiamension());
    imElements = imElements.concat(this.getInspectorElementForLeadSpan());
    imElements = imElements.concat(this.getInspectorElementForTerminalGap());
    imElements = imElements.concat(this.getInspectorElementForTerminalLength());
    imElements = imElements.concat(this.getInspectorElementForTerminalWidth());
    imElements = imElements.concat(this.getInspectorElementForBodyLength());
    imElements = imElements.concat(this.getInspectorElementForBodyHeight());
    imElements = imElements.concat(this.getInspectorElementForMapping());
    imElements = imElements.concat(this.getInspectorElementForTolerance());

    this.inspectorElements.input_elements = imElements;
    return this.inspectorElements;
};